import React from 'react'

import { TabelaColuna, TabelaDados } from 'src/componentes'
import { formatadores } from 'src/paginas/aluno/painel-financeiro/pagina-financeiro/formatadores'

export const colunaDataEmissaoCertificado = (): TabelaColuna => ({
  Chave: 'dataEmissaoCertificado',
  Texto: 'Data Emissão Certificado',
  StyleColuna: { width: 100, paddingInline: 10 },
  Renderizar: (linha: TabelaDados) => (
    <>{formatadores.dataLocaleString(linha.dataEmissaoCertificado)}</>
  )
})
